<div class="row">
  <div class="col-md-12">
    <h3>Package Contents</h3>
    <label class="label">Select a blend:</label>
    <label class="custom-radio">
      <input
        type="radio"
        name="prediction"
        [value]="0"
        [(ngModel)]="selectedBlend"
        (ngModelChange)="onBlendChange($event)"
      />
      <span class="checkmark">1</span>
    </label>
    <label class="custom-radio">
      <input
        type="radio"
        name="prediction"
        [value]="1"
        [(ngModel)]="selectedBlend"
        (ngModelChange)="onBlendChange($event)"
      />
      <span class="checkmark">2</span>
    </label>
    <label class="label">Select a package:</label>
    <label class="custom-radio">
      <input
        type="radio"
        name="package"
        [value]="0"
        [(ngModel)]="selectedPackage"
        (ngModelChange)="onPackageChange($event)"
      />
      <span class="checkmark">1</span>
    </label>
    <label class="custom-radio">
      <input
        type="radio"
        name="package"
        [value]="1"
        [(ngModel)]="selectedPackage"
        (ngModelChange)="onPackageChange($event)"
      />
      <span class="checkmark">2</span>
    </label>
  </div>
</div>
<div class="package-row">
  <h3>Package</h3>
  <h3 style="color: black; font-weight: normal">
    {{ headerData[selectedPackage]?.[0] || "" }}
  </h3>
</div>
<div class="dilution-row">
  <h6>DI in FO [wt%]</h6>
  <span class="dilution-value">{{ currentDiInFO }}</span>
  <h6>Dil. Oil in FO [wt%]</h6>
  <span class="dilution-value">{{ currentDilOilInFO }}</span>
  <h6>Dil. Oil in DI [wt%]</h6>
  <input
    type="text"
    class="dilution-input"
    placeholder="%"
    [value]="currentDilPer || ''"
    (blur)="handleDilutionChange($event)"
  />
</div>
<div class="table-container">
  <table>
    <thead>
      <tr>
        @for (header of tableHeaders; track header) {
          <th>{{ header }}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of currentTableData; track trackByRowId($index, row)) {
        <tr>
          <td>
            <span class="manual-row-cell">
              <button
                class="delete-btn"
                (click)="deleteRow($index)"
                title="Delete row"
              >
                ×
              </button>
              <span class="row-id">{{ row.id }}</span>
            </span>
          </td>
          <td class="left">
            <div class="custom-select-wrapper">
              <input
                type="text"
                class="custom-select-input"
                placeholder="Select an additive..."
                [formControl]="getComponentControl($index)"
                [matAutocomplete]="auto"
                (input)="onComponentInput($index, $any($event.target).value)"
                (blur)="onComponentInputBlur($index)"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onAdditiveSelected($event, $index)"
                panelClass="custom-autocomplete-panel"
              >
                <cdk-virtual-scroll-viewport
                  itemSize="24"
                  class="autocomplete-viewport"
                >
                  <mat-option
                    *cdkVirtualFor="
                      let additive of getFilteredAdditives($index)
                    "
                    [value]="additive"
                  >
                    {{ additive }}
                  </mat-option>
                </cdk-virtual-scroll-viewport>
              </mat-autocomplete>
            </div>
          </td>
          <td>
            <input
              type="text"
              [value]="row.treatRate"
              (input)="handleInputChange($event, $index, 'treatRate')"
              (blur)="handleTreatRateChange($event, $index)"
            />
          </td>
          <td class="center">{{ row.unit }}</td>
          <td>{{ row.wtInFO | number: "1.4-4" }}</td>
          <td>{{ row.wtInDI | number: "1.4-4" }}</td>
          <td class="center">{{ row.blendMetal }}</td>
          <td>{{ row.typical | number: "1.4-4" }}</td>
        </tr>
      }
      <!-- Fila de totales -->
      <tr class="total-row">
        <td></td>
        <td class="left"><strong>Total</strong></td>
        <td></td>
        <td></td>
        <td>
          <strong>{{ calculateTotals().wtInFOTotal | number: "1.4-4" }}</strong>
        </td>
        <td>
          <strong>{{ calculateTotals().wtInDITotal | number: "1.4-4" }}</strong>
        </td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>
</div>
<div class="legend">
  <p (click)="addRow()">add another +</p>
</div>
